const catchGrapesJsErrors = (editor) => {
    editor.on('log:error', (err) => {throw err;})
}

export default catchGrapesJsErrors;